import { App } from 'vue'
import { useMenuStore } from "@/store/menu"

export function directives(app: App) {
    // 权限验证
    permissionDirective(app)
}

/**
 * 权限判断
 * @description v-permission="['sys.list','sys.create']
 */
function permissionDirective(app: App) {
    app.directive('permission', {
        mounted(el, binding) {
            const { value } = binding
            if (value && value instanceof Array && value.length>0) {
                const permissions = useMenuStore().permissions
                if(permissions && permissions instanceof Array){
                    //只需包含其中一个
                    const hasPermission = permissions.some(permission => {
                        return value.includes(permission)
                    })
                    if (!hasPermission) {
                        if (el.parentNode) {
                            el.parentNode.removeChild(el);
                        }
                    }
                }

            }else {
                throw new Error(`need permission! Like v-permission="['sys.list','sys.create']"`)
            }
        }
    })
}

